import {type Item} from '@/api/items';
import {type ModerationTask} from '@/api/moderationQueue';
import {PLATFORM_ID} from '@/lib/platform';

// A queued task as the shared item components and the classify dialog take it.
export const toItem = (task: ModerationTask): Item => ({
  id: task.item_id,
  external_id: task.external_id,
  platform: task.platform,
  // Falcon only ever submits Actors - a pin escalated into this queue is background evidence
  // about its author, never submitted as content in its own right (see ClassificationsController's
  // own enforcement of this; forcing it here too keeps the dialog's own Actor-only UI accurate,
  // e.g. hiding the Content-only fields it would otherwise show for a 'pin' content_type).
  content_type: PLATFORM_ID === 'pinterest' ? 'actor' : task.content_type,
  title: task.title ?? null,
  url: task.url ?? null,
  thumbnail_url: task.thumbnail_url ?? null,
  author_handle: task.author_handle ?? null,
  author_id: task.author_id ?? null,
  author_name: task.author_name ?? null,
  published_at: task.published_at ?? null,
  metadata: task.metadata ?? {},
  affiliate: task.affiliate,
  created_at: task.created_at,
  submission_status: null,
  submission_policy_violations: [],
  submission_status_groups: [],
  item_status: null,
  is_new_item: null
});
